import React, { PureComponent, Fragment } from 'react'
import styles from './ExposureResource.scss'
import { Element } from 'react-scroll'

export default class ExposureResource extends PureComponent {
  render() {
    return (
      <Fragment>
        <style jsx>{styles}</style>
        <Element name="exposureResource" />
        <div className="exposureResource">
          <h2>曝光資源</h2>
          <div className="flex-wrap">
            <div className="box">
              <div className="img">
                <img src="/statics/images/creator/landingPage/exposureResourcePopdaily.png" />
              </div>
              <p>PopDaily網站首頁</p>
            </div>
            <div className="box">
              <div className="img">
                <img src="/statics/images/creator/landingPage/exposureResourceApp.png" />
              </div>
              <p>PopDaily APP推播曝光</p>
            </div>
          </div>
          <div className="flex-wrap">
            <div className="box translate">
              <div className="img">
                <img src="/statics/images/creator/landingPage/exposureResourceDiversion.png" />
              </div>
              <p>PopDaily各類紛絲團社群導流</p>
            </div>
            <div className="box">
              <div className="img">
                <img src="/statics/images/creator/landingPage/exposureResourceInstagram.png" />
              </div>
              <p>PopDaily各類instagram限動曝光</p>
            </div>
          </div>
        </div>
      </Fragment>
    )
  }
}
